import { createRoot, type Root } from "react-dom/client";

import i18n from "./i18n";
import { setCountryCode } from "./settings";
import { Widget, type WidgetProps } from "./Widget";

declare global {
  interface Window {
    KA_Widget: {
      _root?: Root;
      init: (elementId: string, props: WidgetProps) => void;
      unmount: () => void;
    };
  }
}
let root: undefined | Root;

window.KA_Widget = {
  init: (elementId: string, props: WidgetProps) => {
    const el = document.getElementById(elementId);

    if (!el) {
      console.error(`Element with ID '${elementId}' could not be found.`);

      return;
    }
    setCountryCode(props.countryCode);
    switch (props.language) {
      case "sv":
        i18n.changeLanguage("sv");
        break;
      case "fi":
        i18n.changeLanguage("fi");
        break;
      case "en":
        i18n.changeLanguage("en");
        break;
      default: {
        const exhaustiveCheck: never = props.language;
        console.error(`Unsupported language: ${exhaustiveCheck}`);
        break;
      }
    }

    root = createRoot(el);
    root.render(<Widget {...props} />);
  },
  unmount: () => {
    if (root) {
      root.unmount();
    }
  },
};
